import _ from 'lodash';
import axios from 'axios';

/**
 *  Generic set of methods to help extract errors and other error related handlers such as message genators. These are designed to be used only within this 'api-utils'.
 */

function _getErrorMessage({ data, status }) {
  let message = undefined;

  const _data = !!data ? data : {}; // better than using default params which won't deal with 'null';

  // used an array here in case we want to add more possible regex checks in future
  const exceptionRegExs = [/^exception\./g, /^warning\./g, /^errormsg\./g, /\.LessException/g];

  // is this a handled exception
  _.some(exceptionRegExs, (r) => {
    if (r.test(_data.statuscode)) {
      message = _data.statusmsg;
      return true;
    }
  });

  if (!message) {
    // if not we have some canned responses to prevent users being subjected to a hibernate, mySQL or otherwise confusing error message
    switch (status) {
      case 400:
        message = 'There was an error processing your request. Please contact support if you need assistance.';
        break;
      case 401:
        message =
          'You are not currently logged in. Your session may have expired do to inactivity,  please login and try again.';
        break;
      case 403:
        message =
          'You are not authorized. You may have obtained this link from a colleague with different permissions. Please contact your account administrator to review or change your user role.';
        break;
      case 404:
        message = 'There was a problem communicating with the service. Please contact support if you need assistance.';
        break;
      case 408:
        message = 'The request to the service timed out. Please contact support if you need assistance.';
        break;
      case 500:
        message = 'The platform encountered an unknown error. Please contact support if you need assistance.';
        break;
      case 503:
      case 504:
      default:
        message =
          'The platform is experiencing an issue at this time and cannot perform the operation. Please try again later.';
        break;
    }
  }
  return message;
}

export const _getDataErrors = (response, predicate) => {
  const { data } = response;

  if (!!_.get(data, 'failed', null) && !!predicate) return _.map(data.failed, (error) => error.message);
  if (!!_.get(data, 'content.errors', null) && !!predicate) return _.map(data.content.errors, (error) => error.message);
  return [];
};

//if the response header is identified as an error by Axios, it will push the response header object deeper inside the response object,so we require a deeper search as a fallback
export const _extractAxiosResponse = (response) => {
  if (axios.isAxiosError(response) && !!response.response) return response.response;
  //deep dive in the object to pick up axios error response
  else return response; //returning entire response object response
};

export const _normalizeResponse = (response) => {
  if (!response) return response;
  if (!_.isObject(response.data)) response.data = {};
  if (!_.isString(response.data.status)) {
    // blob (and any other non-JSON) responses don't carry a status field by design (see _validateNotOK),
    // so treat them as 'ok'
    response.data.status = _.get(response, 'config.responseType') === 'blob' ? 'ok' : '';
  }

  //lowercase status for ease of camparison with later validators and for the consuming ck message status
  response.data.status = response.data.status.toLowerCase();
  return response;
};

export const _buildErrorObject = (response) => {
  const { status, data } = response;

  return {
    message:       _getErrorMessage({ data, status }),
    rawResponse:   response,
    httpCode:      status,
    responseType:  _.get(data, 'status', ''),
    requestId:     _.get(data, 'requestId', ''),
    requestUrl:    _.get(data, 'request', ''),
    statusCode:    _.get(data, 'statuscode', ''),
    statusMessage: _.get(data, 'statusmsg', ''),
  };
};
